import * as Sentry from '@sentry/react'
import * as FullStory from '@fullstory/browser'

export const checkLocalStorage = () => {
  const test = 'test'
  try {
    localStorage.setItem(test, test)
    localStorage.removeItem(test)
    return true
  } catch (e) {
    return false
  }
}

export const initSentry = () => {
  try {
    Sentry.init({
      dsn: process.env.REACT_APP_SENTRY,
    })
  } catch (err) {
    console.error(err)
  }
}

export const initFullStory = () => {
  try {
    FullStory.init({ orgId: process.env.REACT_APP_FULLSTORY })
  } catch (err) {
    console.error(err)
  }
}

export const sendPostMessage = (eventName, eventData) => {
  try {
    const message = JSON.stringify({
      event_name: eventName,
      event_data: eventData || null,
    })

    return window?.parent?.postMessage(message, '*')
  } catch (err) {}
}
